/* eslint-disable */


// Programatically generated on Mon Mar 09 2026 22:32:44 GMT+0000
import {fromJS, List, Map, Record, Set} from 'immutable';
import {GenericModel} from 'resources/Generic.model';
import {validate, Empty} from '@albert-io/json-api-framework/models/helpers';
import moment from 'moment';

const ModelConfig = fromJS(
  {
    'endpoint': 'districts_v1',
    'attributes': {
      'total_operational_charter_schools': {
        'type': 'integer',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'county': {
        'type': 'string',
        'isRequired': true,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'name': {
        'type': 'string',
        'isRequired': true,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'state': {
        'type': 'string',
        'isRequired': true,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'total_operational_public_schools': {
        'type': 'integer',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'clever_id': {
        'type': 'string',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'nces_locale': {
        'type': 'string',
        'isRequired': true,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'nces_id': {
        'type': 'string',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'updated_at': {
        'type': 'datetime',
        'isRequired': false,
        'isReadOnly': true,
        'isWriteOnly': false
      },
      'total_operational_schools': {
        'type': 'integer',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'inserted_at': {
        'type': 'datetime',
        'isRequired': false,
        'isReadOnly': true,
        'isWriteOnly': false
      },
      'id': {
        'type': 'binary_id',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      }
    },
    'relationships': {
      'schools_v4': {
        'type': 'one-to-many'
      },
      'schools_v5': {
        'type': 'one-to-many'
      }
    }
  }
);

const ModelRecord = Record(
  {
    'total_operational_charter_schools': Empty,
    'county': Empty,
    'name': Empty,
    'state': Empty,
    'total_operational_public_schools': Empty,
    'clever_id': Empty,
    'nces_locale': Empty,
    'nces_id': Empty,
    'updated_at': Empty,
    'total_operational_schools': Empty,
    'inserted_at': Empty,
    'id': Empty,
    'relationshipMeta': Empty,
    'schools': Empty,
    'meta': new Map({
    'populated_metadata_fields': Empty
  })
  }
);

const DefaultModel = fromJS(
  {
    'total_operational_charter_schools': 0,
    'county': '',
    'name': '',
    'state': '',
    'nces_id': '',
    'id': '',
    'inserted_at': new Date(),
    'schools': new List(),
    'meta': new Map(),
    'total_operational_public_schools': 0,
    'clever_id': '',
    'nces_locale': '',
    'updated_at': new Date(),
    'total_operational_schools': 0,
    'relationshipMeta': new Map()
  }
);

export class DistrictModelV1 extends GenericModel(ModelRecord, ModelConfig, 'DistrictModelV1') {
  // -- Query Rules --
  /**
   * @returns {boolean}
   */
  static allowsInclude(include) {
    // AllowedIncludes is currently disabled.
    return true; // AllowedIncludes.has(include);
  }

  /**
   * @returns {boolean}
   */
  static allowsFilter(filterField, filterType) {
    return filterType ?
      FilterRules.get(filterField).has(filterType) :
      FilterRules.has(filterField);
  }

  /**
   * @returns {boolean}
   */
  static allowsSort(sort) {
    return sort.split(',').filter((s) => AllowedSorts.has(s)).length > 0;
  }

  /**
   * @returns {Array}
   */
  static getAllowedSorts() {
    return AllowedSorts.keySeq().toJS();
  }

  static getMetaContextQuery(key) {
    if (!MetadataContextRules.hasIn(['optional', key]) && !MetadataContextRules.hasIn(['required', key])) {
      console.error('Rule for meta context key ' + key + ' does not exist');
    }

    return MetadataContextRules.getIn(['optional', key]) || MetadataContextRules.getIn(['required', key]);
  }

  /**
   * @returns {Immutable.Set}
   */
  static getRequiredMetaContextRules() {
    return new Set([...MetadataContextRules.get('required').values()]);
  }

  /**
   * @returns {Immutable.Set}
   */
  static getAllMetaContextRules() {
    return new Set([...MetadataContextRules.get('required').values(), ...MetadataContextRules.get('optional').values()]);
  }

  static getDefaultModel() {
    _emptyDistrictModelV1Model = _emptyDistrictModelV1Model ? _emptyDistrictModelV1Model : new DistrictModelV1(DefaultModel);
    return _emptyDistrictModelV1Model;
  }

  static supportsMetaContext() {
    return MetadataContextRules !== null;
  }

  /**
   * @returns {string}
   */
  static getModelName() {
    return 'DistrictModelV1';
  }

  /**
   * @returns {boolean}
   */
  static _isFullSpec() {
    return true;
  }

  constructor() {
    super(...arguments);
    this.__meta = null;
  }

  /**
   * @returns {string}
   */
  getJsonApiType() {
    return 'district_v1';
  }

  /**
   * @params {string} - An attribute name
   * @params {*} [def] - Optional default value override for the attribute
   */
  getValueForAttribute(attribute, def) {
    let value = this.get(attribute);
    validate(value, attribute);
    if (value === Empty) {
      value = def !== undefined ? def : DefaultModel.get(attribute);
    }
    return value;
  }

  // -- Primary Attributes --
  
  /**
   * @type {string}
   */
  getCleverId() {
    const value = this.getValueForAttribute('clever_id');
    return value;
  }

  setCleverId(value) {
    return this.setField('clever_id', value);
  }

  /**
   * @type {string}
   */
  getCounty() {
    const value = this.getValueForAttribute('county');
    return value;
  }

  setCounty(value) {
    return this.setField('county', value);
  }

  /**
   * @type {binary_id}
   */
  getId() {
    const value = this.getValueForAttribute('id');
    return value;
  }

  setId(value) {
    return this.setField('id', value);
  }

  /**
   * @type {datetime}
   */
  getInsertedAt() {
    const value = this.getValueForAttribute('inserted_at');
    
      const momentValue = moment(value);
      return momentValue.isValid() ? momentValue : value;
    
  }

  /**
   * @type {string}
   */
  getName() {
    const value = this.getValueForAttribute('name');
    return value;
  }

  setName(value) {
    return this.setField('name', value);
  }

  /**
   * @type {string}
   */
  getNcesId() {
    const value = this.getValueForAttribute('nces_id');
    return value;
  }

  setNcesId(value) {
    return this.setField('nces_id', value);
  }

  /**
   * @type {string}
   */
  getNcesLocale() {
    const value = this.getValueForAttribute('nces_locale');
    return value;
  }

  setNcesLocale(value) {
    return this.setField('nces_locale', value);
  }

  /**
   * @type {string}
   */
  getState() {
    const value = this.getValueForAttribute('state');
    return value;
  }

  setState(value) {
    return this.setField('state', value);
  }

  /**
   * @type {integer}
   */
  getTotalOperationalCharterSchools() {
    const value = this.getValueForAttribute('total_operational_charter_schools');
    
      const int = parseInt(value, 10);
      return isNaN(int) ? value : int;
    
  }

  setTotalOperationalCharterSchools(value) {
    return this.setField('total_operational_charter_schools', value);
  }

  /**
   * @type {integer}
   */
  getTotalOperationalPublicSchools() {
    const value = this.getValueForAttribute('total_operational_public_schools');
    
      const int = parseInt(value, 10);
      return isNaN(int) ? value : int;
    
  }

  setTotalOperationalPublicSchools(value) {
    return this.setField('total_operational_public_schools', value);
  }

  /**
   * @type {integer}
   */
  getTotalOperationalSchools() {
    const value = this.getValueForAttribute('total_operational_schools');
    
      const int = parseInt(value, 10);
      return isNaN(int) ? value : int;
    
  }

  setTotalOperationalSchools(value) {
    return this.setField('total_operational_schools', value);
  }

  /**
   * @type {datetime}
   */
  getUpdatedAt() {
    const value = this.getValueForAttribute('updated_at');
    
      const momentValue = moment(value);
      return momentValue.isValid() ? momentValue : value;
    
  }

  // -- Meta Attributes --
  
    /**
     * LEGACY META ACCESSORS
     * @todo These should no longer be used, instead use this.getMeta()[...]
     */
    
      getPopulatedMetadataFields() {
        return this.getMeta().getPopulatedMetadataFields();
      }
    
    getMeta() {
      if (this.__meta) {
        return this.__meta;
      }
      const meta = this.get('meta', Map());
      this.__meta = {
        
          /**
           * @type {string[]}
           */
          getPopulatedMetadataFields() {
            const value = meta.get('populated_metadata_fields');
            validate(value, 'populated_metadata_fields');
            return value;
          },
  
      };
      return this.__meta;
    }
  
  // -- Relationships --
  
  /**
   * @type {school_v5 (many)}
   */
  getSchools() {
    const value = this.getValueForAttribute('schools');
    return value;
  }

  // -- Relationship Fields: schools --
  // no 'fields' found, skipped generating accessor(s)
  
}

// -- Empty Model Instance --
let _emptyDistrictModelV1Model = null;

// -- Sort Rules --

const AllowedSorts = fromJS({
  'clever_id': null,
  'county': null,
  'id': null,
  'inserted_at': null,
  'name': null,
  'nces_id': null,
  'nces_locale': null,
  'state': null,
  'total_operational_charter_schools': null,
  'total_operational_public_schools': null,
  'total_operational_schools': null,
  'updated_at': null,
});

// -- Include Rules --
// List []

// -- Filter Rules --
const FilterRules = new Map({
  'clever_id': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix','search_keyword']),
  'county': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix','search_keyword']),
  'id': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix','search_keyword']),
  'inserted_at': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'meta.populated_metadata_fields': new Set(['null']),
  'name': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix','search_keyword']),
  'nces_id': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix','search_keyword']),
  'nces_locale': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix']),
  'schools_v4': new Set(['associated']),
  'schools_v5': new Set(['associated']),
  'state': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix','search_keyword']),
  'total_operational_charter_schools': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'total_operational_public_schools': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'total_operational_schools': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'updated_at': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
});
    

// -- Metadata Context Rules --
const MetadataContextRules = fromJS({
  optional: {
  },
  required: {
  }
});

// -- Legacy Name Export --
export const District = DistrictModelV1;
